import styled from "styled-components";

export const TicketSupportContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 16px;
  margin-bottom: 16px;
  min-height: 54px;
  max-height: 54px;
  @media screen and (max-width: 599px) {
    justify-content: center;
    margin-top: 0px;
    width: 100%;
    a {
      margin: 0 10px;
    }
    div {
      width: 100%;
    }
  }
`;
